// extracted by mini-css-extract-plugin
export default {"table-items":"ProdTable_table-items__772ap"};